import React, { useEffect, useState } from 'react'
import { Drawer, Row, Col, Select, Button, Form, Input, Alert, notification } from 'antd'
import InputBox from '../../../components/_utils/InputBox'
import { addWithdrawalIssueFxn } from '../actions/commissionAction'
import { useDispatch } from 'react-redux'
import { CountryCodeWithFlag } from '../../../components/_utils/countryUtil'
import { getSingleUser } from '../../users/actions/user'

const { Option } = Select
const { TextArea } = Input
let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null

const WithdrawalIssueDrawer = (props) => {
  let dispatch = useDispatch()
  const { visible, onClose, record, agentCommissionId } = props
  const [issue, setIssue] = useState('')
  const [note, setNote] = useState('')
  const [userData, setUserData] = useState('')
  const getSingleUserFxn = async () => {
    if (user._id) {
      let filters = { userId: user._id }
      let data = await dispatch(getSingleUser(filters))
      setUserData(data)
    }
  }
  useEffect(() => {
    getSingleUserFxn()
  }, [])

  let initialContactDetails = {
    name: userData.name || '',
    countryCode: userData.countryCode || '',
    mobile: userData.mobile || '',
    position: ''
  }
  const [contactDetails, setContactDetails] = useState(initialContactDetails)

  const issueList = [
    { name: 'Funds not received' },
    { name: 'Funds transferred to wrong account' },
    { name: 'Matter of urgency' },
    { name: 'Other' }
  ]

  const handleSubmit = async () => {
    if (!issue) {
      return notification.warning({ message: 'Please Select Withdrawal Issue' })
    }
    if (!note) {
      return notification.warning({ message: 'Please Add Details' })
    }
    let obj = {
      note,
      issue,
      withdrawalId: record._id,
      status: 'Pending',
      agentCommissionId
    }
    if (issue == 'Matter of urgency') {
      if (!contactDetails.name) {
        return notification.warning({
          message: 'Please Enter Name'
        })
      }
      if (!contactDetails.countryCode) {
        return notification.warning({
          message: 'Please Choose Country Code'
        })
      }
      if (!contactDetails.mobile) {
        return notification.warning({
          message: 'Please Enter Mobile'
        })
      }

      if (!contactDetails.position) {
        return notification.warning({
          message: 'Please Enter Position'
        })
      }
      obj.contactDetails = contactDetails
    }

    let resp = await dispatch(addWithdrawalIssueFxn(obj))
    if (resp && resp.success) {
      setNote('')
      setIssue('')
      onClose()
    }
  }


  const renderNoteSection = () => {
    if (!issue) return null

    return (
      <>
        <Form.Item style={{ width: '100%' }}>
          <InputBox title='Add Details *'>
            <TextArea
              rows={4}
              placeholder='Write your details here'
              value={note}
              onChange={(e) => setNote(e.target.value)}
              style={{ width: '100%' }}
            />
          </InputBox>
        </Form.Item>

        {issue === 'Funds not received' && (
          <Alert
            type='warning'
            showIcon
            message='Processing takes approximately 7 to 10 days after TT upload. We recommend waiting before raising a concern.'
            style={{ marginBottom: 16 }}
          />
        )}

        {issue === 'Matter of urgency' && (
          <>
            <Form.Item style={{ width: '100%' }}>
              <InputBox title='Name *'>
                <Input
                  className={'form-control'}
                  placeholder='Enter Name...'
                  value={contactDetails.name}
                  onChange={(e) => setContactDetails({ ...contactDetails, name: e.target.value })}
                  style={{ width: '100%' }}
                />
              </InputBox>
            </Form.Item>

            <Row gutter={16}>
              <Col span={8}>
                <CountryCodeWithFlag
                  countryCode={contactDetails.countryCode}
                  chooseCode={(val) => {
                    setContactDetails({ ...contactDetails, countryCode: val })
                  }}
                />
              </Col>
              <Col span={16}>
                <InputBox title='Mobile *'>
                  <Input
                    className={'form-control'}
                    placeholder='Enter Mobile...'
                    value={contactDetails.mobile}
                    onChange={(e) => setContactDetails({ ...contactDetails, mobile: e.target.value })}
                    style={{ width: '100%' }}
                  />
                </InputBox>
              </Col>
            </Row>

            <Form.Item style={{ width: '100%' }}>
              <InputBox title='Position *'>
                <Input
                  className={'form-control'}
                  placeholder='Enter Position...'
                  value={contactDetails.position}
                  onChange={(e) =>
                    setContactDetails({ ...contactDetails, position: e.target.value })
                  }
                  style={{ width: '100%' }}
                />
              </InputBox>
            </Form.Item>

            <Alert
              type='warning'
              showIcon
              message='Please ensure your contact number, name, and position are included. We will contact you within 1 hour.'
              style={{ marginBottom: 16 }}
            />
          </>
        )}
      </>
    )
  }

  return (
    <Drawer
      title={`Withdrawal Issue / Not Received Funds`}
      visible={visible}
      onClose={onClose}
      width={'35%'}
    >
      <div className='card unizportal'>
        <Form
          className='vertical-form'
          autoComplete='off'
          layout='vertical'
        >
          <Form.Item style={{ width: '100%' }}>
            <InputBox title={'Choose Issue *'}>
              <Select
                placeholder='Choose Issue'
                value={issue}
                onChange={(value) => {
                  setIssue(value)
                  setNote('')
                  setContactDetails(initialContactDetails)
                }}
                style={{ width: '100%' }}
              >
                {issueList.map((issue) => (
                  <Option key={issue.name} value={issue.name}>
                    {issue.name}
                  </Option>
                ))}
              </Select>
            </InputBox>
          </Form.Item>

          {renderNoteSection()}

          <Form.Item style={{ width: '100%' }}>
            <Button type='primary' htmlType='submit' onClick={handleSubmit}>
              SUBMIT
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Drawer>
  )
}

export default WithdrawalIssueDrawer
